import profileA from '../asset/image/profile/A.svg';
import profileB from '../asset/image/profile/B.svg';
import profileC from '../asset/image/profile/C.svg';
import profileD from '../asset/image/profile/D.svg';

export const DEFAULT_PROFILE_AVATARS = [profileA, profileB, profileC, profileD];

/**
 * 사용자 ID mod 4에 따라 기본 프로필 이미지 반환 (0→A, 1→B, 2→C, 3→D).
 */
export function getDefaultProfileAvatar(userId) {
  const id = Number(userId);
  if (!Number.isFinite(id)) {
    return DEFAULT_PROFILE_AVATARS[0];
  }
  const index = ((id % 4) + 4) % 4;
  return DEFAULT_PROFILE_AVATARS[index];
}
